import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="container-page flex flex-col items-center justify-center py-24 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className="ri-compass-3-line text-3xl" aria-hidden="true"></i>
      </span>
      <h1 className="mt-5 font-heading text-3xl font-semibold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你访问的页面可能已被移动或不存在，可以回到首页继续浏览作品与动态。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700 cursor-pointer"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-1.5 rounded-md border border-background-300/70 px-5 py-2.5 text-sm text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          浏览作品
        </Link>
      </div>
    </div>
  );
}